module.exports = {
  COUNTRY: 'country-select',
  BASIC: 'basic-info',
  ADDRESS: 'address',
  COMPLETE: 'complete'
};
